import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify)
const opts = {}
export default new Vuetify(opts)